var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard3Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 165,
    viewBox: "0 0 188 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 68C8.16667 67.1666 21.8 68.6 27 81C31.1667 82.6666 41.5 85.5 49.5 83.5",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 91H47.5",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 46C10.6667 44.5 26.3 47 27.5 69C31 73.1667 41.3 80.9 54.5 78.5",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 91H188",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127 38.9866L93.5 72.4866C97.9 74.4866 98.6667 81.6533 98.5 84.9866H145.5C149.5 61.3866 134.833 44.4866 127 38.9866Z",
    fill: "#1AD079"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4768 13.6744L73.8742 61.0489C78.3853 59.3139 84.0328 63.7922 86.2926 66.2482L119.247 32.7366C105.224 13.3374 82.8908 11.9454 73.4768 13.6744Z",
    fill: "#1AD079"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.57 93.2999L99.1994 94.0436C100.967 98.5419 96.5304 104.222 94.091 106.5L127.843 139.208C147.139 125.044 148.367 102.701 146.57 93.2999Z",
    fill: "#83899D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.765 144.596L85.8628 111.503C83.9161 115.927 76.7592 116.78 73.4241 116.653L73.9919 163.65C97.6385 167.365 114.36 152.495 119.765 144.596Z",
    fill: "#83899D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 90,
    r: 18,
    fill: "#1AD079"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 113C8.33333 113.333 19.5 112.2 21.5 105C23.5 100.667 31.7 92.9 48.5 96.5",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 134.5C6.83333 135.667 19.6 134.2 24 119C27.3333 111.333 37.7 97.3 52.5 102.5",
    stroke: "#1AD079",
    strokeDasharray: "4 4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3Img);
export default __webpack_public_path__ + "static/media/card_3_img.e741e5487c137008caa55d015ac1b48c.svg";
export { ForwardRef as ReactComponent };